import { Info } from '@mui/icons-material'
import { ReactElement } from 'react'
import { I18n, Translate } from 'common'
import { defaultTheme } from '../../../../../../src/theme/index'
import styled from 'styled-components'
import { Hyperlink } from '../../../../../../src/ui-components/util/Hyperlink'
import { useNavigate } from 'react-router-dom'
import { breakpoints } from '../../../../../../src/theme/breakpoints'

interface Props {
  partNumber: string
}

const InterchangeInfoMessage = (props: Props): ReactElement => {
  const { partNumber } = props
  const navigate = useNavigate()

  const partName = `${partNumber}`
  const message = Translate('interchangeInfoMessage', ['&', partName]) // We'll replace the & by a react component
  const [firstPart, secondPart] = message.split('&')

  const goToCrossReferenceResults = (): void => {
    navigate(`/cross-reference?partNumber=${partNumber}`)
  }

  const Link = (
    <Hyperlink action={goToCrossReferenceResults}>
      <I18n name="crossReferenceTool" />
    </Hyperlink>
  )

  return (
    <Wrapper>
      <IconSection>
        <StyledIcon />
      </IconSection>
      <MessageSection>
        <span>
          {firstPart} {Link} {secondPart}
        </span>
      </MessageSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  height: 72px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${defaultTheme.colors.white};
  gap: 16px;
  padding: 12px 20px 12px 20px;
  align-items: center;
  @media screen and (width <= ${breakpoints.mobileLarge}px) {
    height: fit-content;
  }
`

const IconSection = styled.div``

const StyledIcon = styled(Info)`
  color: ${defaultTheme.colors.warningBackground};
`

const MessageSection = styled.div``

export default InterchangeInfoMessage
